import { ArrowLeft, Flag, AlertTriangle } from "lucide-react";
import { Button } from "../../components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { ScrollArea } from "../../components/ui/scroll-area";
import { Avatar, AvatarFallback } from "../../components/ui/avatar";
import { useNavigate } from "react-router-dom";

const ChatDetail = ({
  setSelectedChat,
  selectedChat,
  messages,
}) => {
  const navigate = useNavigate();
  
  console.log("Messages", messages);

  const handleViewReport = () => {
    // Navigate to reports page with chat ID to find and open the related report
    navigate('/admin/reports', {
      state: { 
        chatId: selectedChat.id,
        autoOpenReport: true,
        filterType: 'chat'
      }
    });
  };
  
  return (
    <div className="space-y-6">
      <Button
        variant="outline"
        onClick={() => setSelectedChat(null)}
        className="mb-4"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to Chat List
      </Button>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center justify-between">
            <div>
              <span>Chat: {selectedChat.id}</span>
              <div className="text-sm font-normal text-gray-500 mt-1">
                {selectedChat.users.join(" ↔ ")}
              </div>
            </div>
            <div className="flex space-x-2">
              {selectedChat.flagged && (
                <>
                  <Badge variant="destructive" className="p-2">
                    <Flag className="w-3 h-3 mr-1" />
                    Flagged
                  </Badge>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={handleViewReport}
                    className="text-red-600 border-red-600 hover:bg-red-50"
                  >
                    <AlertTriangle className="w-4 h-4 mr-1" />
                    View Report
                  </Button>
                </>
              )}
            </div>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ScrollArea className="h-96 border rounded-lg p-4">
            <div className="space-y-4">
              {messages.map((message) => (
                <div
                  key={message.id}
                  className={`flex space-x-3 ${
                    message.flagged ? "bg-red-50 p-2 rounded" : ""
                  }`}
                >
                  <Avatar className="w-8 h-8">
                    <AvatarFallback>
                      {message.sender
                        .split(" ")
                        .map((n) => n[0])
                        .join("")}
                    </AvatarFallback>
                  </Avatar>
                  <div className="flex-1">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-2">
                        <span className="font-medium text-sm">
                          {message.sender}
                        </span>
                        <span className="text-xs text-gray-500">
                          {message.time}
                        </span>
                        {message.flagged && (
                          <Badge variant="destructive" className="text-xs">
                            <Flag className="w-3 h-3 mr-1" />
                            Flagged
                          </Badge>
                        )}
                      </div>
                    </div>
                    <p className="text-sm text-gray-700 mt-1">
                      {message.message}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </ScrollArea>
        </CardContent>
      </Card>
    </div>
  );
};

export default ChatDetail;